// Global VRM cache to persist across component unmounts and page refreshes
export const globalVRMCache = {
  main: null as any,
  idle: null as any,
  greeting: null as any,
  speaking: null as any,
  mainLoaded: false,
  idleLoaded: false,
  greetingLoaded: false,
  speakingLoaded: false,
};

// VRM file paths (relative to S3 bucket, loaded via /api/proxy/vrm/)
export const VRM_ANIMATION_PATHS = {
  IDLE: 'ellie_iddle.vrma',
  GREETING: 'ellie_greeting_v17.vrma',
  SPEAKING: 'Ellie_speaking04.vrma',
} as const;

export const VRM_MODEL_PATH = 'ellie_main_v12.vrm';

// Animation settings
export const ANIMATION_CONFIG = {
  SPEAKING_VOLUME_THRESHOLD: 0.01,
  HEAD_ROTATION_SCALE: 0.3,
  NECK_ROTATION_SCALE: 0.2,
  BONE_MOVEMENT_SCALE: 0.0002,
  FACIAL_EXPRESSION_SCALE: 0.5,
} as const;